import { render, staticRenderFns } from "./CookDashboard2.vue?vue&type=template&id=941316be&scoped=true&"
import script from "./CookDashboard2.vue?vue&type=script&lang=js&"
export * from "./CookDashboard2.vue?vue&type=script&lang=js&"
import style0 from "./CookDashboard2.vue?vue&type=style&index=0&id=941316be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941316be",
  null
  
)

export default component.exports